module.exports = __webpack_public_path__ + "img/游戏亮.1c872dcb.png";